import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';

import Button from '~/components/common/Button';
import {modalChange} from '~/modules/modal/actions';
import sharedCSS from '../../shared.css';
import css from './index.css';
import mapDispatch from '~/misc/mapDispatch';
import config from '~/config';

const AnonymousBanner = ({
  userIsLoggedIn, showLogIn, showSignUp, showDownload, anonBanerTextAndAction,
}) => (userIsLoggedIn ? null : (
  <div
    className={cs(sharedCSS.wideStretchable, sharedCSS.box, css.wrap, 'qa-anon-banner')}
  >
    {anonBanerTextAndAction
      ? <span className={(cs('qa-anon-banner-message', css.actionCall))}>
          Sign up to view the details or{' '}
        <span
          className={cs(css.descTitle, css.blueColor)}
          onClick={() => showDownload('homepage download')}
        >download</span>
        {' '}Truckloads App to experience more wonderful features!
      </span>
      : <span className='qa-anon-banner-message'>
          Sign up to view the details or{' '}
        <span
          className={cs(css.descTitle, css.blueColor)}
          onClick={() => showDownload('homepage download')}
        >download</span>
        {' '}Truckloads App to experience more wonderful features!
      </span>
    }

    {anonBanerTextAndAction ? (
      <div className={css.buttons}>
        <Button mods={['action']} onClick={showSignUp} data-qa='anon-banner-signup'>
          Sign up
        </Button>
        {' '}
        <Button mods={['action']} onClick={showLogIn} data-qa='anon-banner-login'>
          Log in
        </Button>

      </div>
    ) : (
      <div className={css.buttons}>
        <Button mods={['action']} onClick={showSignUp} data-qa='anon-banner-signup'>
          Sign up
        </Button>
        {' '}
        <Button mods={['action']} onClick={showLogIn} data-qa='anon-banner-login'>
          Log in
        </Button>
      </div>
    )}

  </div>
));

export default connect(({user: {isLoggedIn}}) => ({
  userIsLoggedIn: isLoggedIn,
  anonBanerTextAndAction: config.anonBanerTextAndAction,
}), mapDispatch({
  showSignUp: () => modalChange('signup', 'anonymous_banner'),
  showLogIn: () => modalChange('login', 'anonymous_banner'),
  showDownload: (props, source) => modalChange('pop', {type: 'pop_download', source: source}),
}))(AnonymousBanner);



// WEBPACK FOOTER //
// ./src/components/search/AnonymousBanner/index.js